<template>
  <div class="ccui-app-container fine-repot">
    <div class="finereport-operate-bar no-print">
      <div class="title">开发人员报表</div>
      <div class="btn-bar">
        <el-button
          size="mini"
          type="primary"
          icon="el-icon-document"
          style="float: right;margin-left: 8px"
          @click="fineExport(filePath, printOption, 'excel')"
          >导出EXCEL
        </el-button>
        <el-button
          size="mini"
          type="primary"
          icon="icon-ccui-print"
          style="float: right;"
          @click="handlePrint"
          >打印
        </el-button>
      </div>
    </div>
    <iframe
      class="no-print"
      id="reportFrame"
      :src="finePageUrl"
      frameborder="0"
    ></iframe>
    <div id="print-page" class="print"></div>
  </div>
</template>

<script>
import fineReport from "@/config/mixins/fineReport";
export default {
  name: "fine-report-report",
  mixins: [fineReport],
  data() {
    return {
      filePath: "demo/demo.list.2.1.cpt",
      encodedFilePath: "demo%252Fdemo.list.2.1.cpt"
    };
  }
};
</script>

<style lang="scss">
@import "~@/config/styles/finereport.scss";
</style>
